<div class="mainImage">
  <div class="darkBg">
    <h1 class="heading">NDIS Plan Managers</h1>
    <h1 class="slogan">We're behind you</h1>
    <h3 class="subheading">
      <small>Supporting participants to use the providers they choose.</small>
    </h3>
    <br />
    <button mat-raised-button class="signUpBtn" routerLink="/service-agreement" role="button">
      Sign up
    </button>
  </div>
</div>

<div class="content-container">
  <!-- Welcome to ADIEM -->
  <h1 class="contentHeading">Welcome to ADIEM</h1>

  <!-- Content List -->
  <div class="content">

    <div class="contentListWrapper">
      <p class="contentList">If you're looking for a plan manager who…</p>
      <ul class="listWrapper">
        <li class="contentList">Will be available when you need</li>
        <li class="contentList">Will watch your plan closely</li>
        <li class="contentList">Answer your questions</li>
        <li class="contentList">Pay your providers on time</li>
        <li class="contentList">Work with your support coordinator</li>
        <li class="contentList">Who really cares</li>
      </ul>
    </div>

    <!-- Image -->
    <div class="contentImage">
      <img src="../../assets/img/girl-doing-yoga-b&w.png" alt="NDIS participant doing yoga">
    </div>
  </div>

  <!-- Talk to Us -->
  <p class="talkToUs">... talk to us</p>

  <!-- Extra Content -->
  <div class="contentListWrapper contentPadding">
    <p class="contentList">
      We'll take care of the financial management of your NDIS plan while you decide what supports you purchase,
      who provides these supports and how they are delivered.
    </p>
    <p class="contentList">Being <strong>Plan-Managed</strong>:</p>

    <ul class="listWrapper">
      <li class="contentList">Allows you to pay a variety of providers whether they are NDIS registered
        or not.
      </li>
      <li class="contentList">Gives you flexibility to move funds between your CORE support budgets.</li>
      <li class="contentList">Keeps you on track with your funding.</li>
      <li class="contentList">Means your finances are taken care of for you.</li>
    </ul>
  </div>

</div>

<!-- Testimonials Section -->
<div class="backgroundImage3">
  <div class="colorFilter">

    <testimonial-fader [testimonials]="testimonials"></testimonial-fader>

  </div>
</div>

<!-- Icons Section -->
<div class="thumbnailsBackground">
  <div class="flex-container">
    <!-- Fast Payments – 2-3 days -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Fast Payments</h2>
      <img class="iconSize" src="../../assets/svg/fast-payment.svg" alt="" />
      <p class="thumbnailDescription">
        Invoices are always paid within 4 - 6 business days
      </p>
    </div>
    <!-- Choice of Provider -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Choice of Provider</h2>
      <img class="iconSize" src="../../assets/svg/provider-choice.svg" alt="" />
      <p class="thumbnailDescription">
        Use any provider you choose
      </p>
    </div>
    <!-- Monthly Statements -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Monthly Statements</h2>
      <img class="iconSize" src="../../assets/svg/monthly-statements.svg" alt="" />
      <p class="thumbnailDescription">
        Receive a monthly statement of your plan balances and transactions
      </p>
    </div>
    <!-- Help & Advice -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Help & Advice</h2>
      <img class="iconSize" src="../../assets/svg/help-support.svg" alt="" />
      <p class="thumbnailDescription">
        We are always available for answering your questions
      </p>
    </div>
    <!-- Participant Portal -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Participant Portal</h2>
      <img class="iconSize" src="../../assets/svg/participant-portal.svg" alt="" />
      <p class="thumbnailDescription">
        Access your plan balances and view invoices from your phone or web browser
      </p>
    </div>
    <!-- Support Coordinator Portal -->
    <div class="thumbnails">
      <h2 class="thumbnailTitle">Support Coordinator Portal</h2>
      <img class="iconSize" src="../../assets/svg/support-coordinator-portal.svg" alt="" />
      <p class="thumbnailDescription">
        Support Coordinators can view all of their participants with ADIEM from one portal
      </p>
    </div>
  </div>
</div>